/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */

export const WEBSITE_URL = 'https://www.membercenter.net';
